import { Link } from "react-router-dom";
import "./ErrorPage.scss";
const ErrorPage = () => {
  return (
    <div className="error">
      <h1 className="error__title">"Oops!"</h1>

      <p>The page you've requested cannot be found.</p>
      <p>Here are some helpful links to get you back on track:</p>
      <Link className="error__link" to="/">
        Home
      </Link>
      <Link className="error__link" to="/MedHelp">
        Helpful Resources
      </Link>
    </div>
  );
};

export { ErrorPage };
